const OTP_REQUEST_TYPE = {
  login: "login",
  mpin_reset: "mpin_reset",
  phone_verification: "phone_verification",
  KASA_ORDERING: "KASA_ORDERING",
  PASSWORD_RESET: "PASSWORD_RESET",
  signup: "signup",
};

const OTP_DELIVERY_CHANNEL = {
  call: "call",
  sms: "sms",
};

const OTP_DELIVERY_CONFIG = {
  call: {
    label: "voice call",
    promptModalConfig: {
      TITLE: `Send OTP via voice call to `,
      PRIMARY_CTA: "Call me",
      SECONDARY_CTA: "Use other methods",
      INSTRUCTION: `Pakinggan at tandaan ang binigay na OTP.
        1 tawag lang pwede kada araw.  Libre ang tawag na ito.`,
    },
  },
  sms: {
    label: "text",
  },
};

const AUTHORIZATION_DELIVERY_CHANNEL_STATUS = {
  ACTIVE: "ACTIVE",
  INACTIVE: "INACTIVE",
};

const AUTHORIZATION_CHANNEL = {
  MPIN: "4-digit password",
  OTP_VIA_SMS: "OTP via text",
  OTP_VIA_CALL: "OTP via voice call",
};

const VERIFY_OTP_GQL_ERROR_CODES = {
  ATTEMPT_EXCEED: "MS-OTP-005",
  WRONG_OTP: "MS-OTP-004",
};

const AUTHORIZATION_OTP_CONFIG = {
  MAX_TRIES: 3,
  ERRORS: {
    INVALID_OTP: `Ilagay ang OTP na pinadala sa\niyong registered mobile\nnumber.`,
    INVALID_OTP_VOICE_CALL: `Ilagay ang OTP na pinadala sa\niyong registered mobile number\nvia voice call.`,
    MAX_INVALID_OTP_REACHED: "Maximum attempts reached. Maaaring subukan muli mamaya.",
  },
  MAX_HOURS_UNBLOCKED: 4,
};

const VERIFY_OTP_ERROR_MODAL = {
  title: "Incorrect OTP",
  title_max_attempts: `Max attempts for OTP reached`,
  message_max_attempts: `Maaaring subukan ang ibang\nmethod o maghintay ng 4\nhours bago subukan ulit\nmag-log in gamit ang OTP`,
};

const HTTP_STATUS_CODE = {
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
};

export {
  OTP_REQUEST_TYPE,
  OTP_DELIVERY_CHANNEL,
  OTP_DELIVERY_CONFIG,
  AUTHORIZATION_DELIVERY_CHANNEL_STATUS,
  AUTHORIZATION_CHANNEL,
  VERIFY_OTP_GQL_ERROR_CODES,
  AUTHORIZATION_OTP_CONFIG,
  VERIFY_OTP_ERROR_MODAL,
  HTTP_STATUS_CODE,
};
